webpackJsonp([86],{

/***/ "/A+z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0iPh":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2Uyi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (win, doc) {
  change();

  function change() {
    doc.documentElement.style.fontSize = doc.documentElement.clientWidth * 14.5 / 375 + "px";
  }
  win.addEventListener("resize", change, false);
  win.addEventListener("orientationchange", change, false);
})(window, document);

/***/ }),

/***/ "2kPC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'tab-item',
  mixins: [_multiItems.childMixin],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "3KG0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  }
  return fmt;
};

exports.default = Date;

/***/ }),

/***/ "9n10":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B5zW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.container,attrs:{"id":"tarBar"}},_vm._l((_vm.icons),function(item,index){return _c('li',{key:item.id,on:{"click":function($event){$event.stopPropagation();return _vm.handleChangeIndexClick(index)}}},[(item.name)?_c('i',{class:[index === _vm.activeIndex ? item.selectIcon: item.icon]}):_vm._e(),_vm._v(" "),(!item.name)?_c('span',{staticClass:"addIcon"}):_vm._e(),_vm._v(" "),_c('p',{class:index === _vm.activeIndex ? _vm.$style.active: ''},[_vm._v(_vm._s(item.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("YV66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("YB+S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff701c6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("lm9P");
function injectStyle (ssrContext) {
  __webpack_require__("eMjD")
  __webpack_require__("LQnx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff701c6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff701c6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EiRk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GVVA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint -W097 */
/* jshint -W117 */



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

var _cookie = __webpack_require__("SXPf");

var _cookie2 = _interopRequireDefault(_cookie);

var _index = __webpack_require__("YaEn");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.baseURL = '/';

/**
 * Axios请求拦截器
//  */
_axios2.default.interceptors.request.use(function (config) {
  var token = _cookie2.default.get('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
}, function (error) {
  return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        _cookie2.default.del('token');
        // 这里写清除token的代码
        _index2.default.replace({
          path: '/signin',
          query: {
            redirect: _index2.default.currentRoute.fullPath // 登录成功后跳入浏览的当前页面
          } });
    }
  }
  return _promise2.default.reject(error.response.data);
});

/**
 * 【单一请求】检查http状态码
 * @param {object} response -- 异步请求返回的数据对象
 * @return {object}  请求正常则返回数据对象data，否则返回自定义错误提示信息对象
 */
function checkStatus(response) {
  // 如果http状态码正常，则直接返回数据 暂时不考虑304 400的情况
  if (response.status === 200) {
    // 这里不需要除了data之外的数据，所以直接 return response.data
    return {
      status: 200,
      data: response.data
    };
  }
  return {
    status: -400,
    msg: '请确认您的网络连接正常，然后点击刷新重试'
  };
}

/**
 * 【单一请求】检查异步请求的后端返回信息码code
 * @param {object} res -- 异步请求返回的数据主体对象
 * @return {object}  code正常则返回数据对象数据主体对象，否则弹出对话框显示msg信息
 */
function checkCode(res) {
  if (res.status === -400) {
    // iView.Modal.error({
    //     title: '温馨提示',
    //     width: 500,
    //     content: res.msg
    // });
    alert(res.msg);
    return false;
  }
  // 如果code异常，可以弹出一个错误提示，告诉用户
  if (res.data.code === 200) {
    return res.data;
  } else {
    // iView.Modal.error({
    //     title: '温馨提示',
    //     width: 500,
    //     content: res.data.msg
    // });
    return false;
  }
}

/**
 * 【并发请求】检查http状态码
 * @param {array} resList
 * @return {object}
 */
function checkAllStatus(resList) {
  var isSuccess = resList.every(function (item) {
    return item.status === 200;
  });
  if (isSuccess) {
    var dataList = resList.map(function (item) {
      return item.data;
    });
    return {
      status: 200,
      data: dataList
    };
  } else {
    return {
      status: -400,
      msg: '请确认您的网络连接正常，然后点击刷新重试'
    };
  }
}

/**
 * 【并发请求】检查异步请求的后端返回信息码code
 * @param {object} resObj
 * @return {object/array}
 */
function checkAllCode(resObj) {
  if (resObj.status === -400) {
    alert(resObj.msg);
    return false;
  }
  var isSuccess = resObj.data.every(function (item) {
    return item.code === 200;
  });
  if (isSuccess) {
    var dataList = resObj.data.map(function (item) {
      return item.data;
    });
    return dataList;
  } else {
    alert('当前服务不可用，请手动刷新后重试');
    return false;
  }
}

/*
 * 获取token，为所有url添加token，无论哪一种请求
 */

// let token = JSON.parse(sessionStorage.getItem('token'));
// console.log(token);
/*
 * Axios封装-get/post/put/delete/all
 */
exports.default = {
  get: function get(url, params) {
    var token = _cookie2.default.get('token');
    params = (0, _assign2.default)({}, params, {
      'access_token': token
    });

    return (0, _axios2.default)({
      method: 'get',
      url: url,
      params: params,
      timeout: 25000
    }).then(checkStatus).then(checkCode);
  },
  post: function post(url, urlParams, bodyParams) {
    var token = _cookie2.default.get('token');
    urlParams = (0, _assign2.default)({}, urlParams, {
      'access_token': token
    });
    url += '?' + _qs2.default.stringify(urlParams);
    return (0, _axios2.default)({
      method: 'post',
      url: url,
      data: (0, _stringify2.default)(bodyParams),
      timeout: 25000,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(checkStatus).then(checkCode);
  },
  put: function put(url, urlParams, bodyParams) {
    var token = _cookie2.default.get('token');
    urlParams = (0, _assign2.default)({}, urlParams, {
      'access_token': token
    });
    url += '?' + _qs2.default.stringify(urlParams);
    return (0, _axios2.default)({
      method: 'put',
      url: url,
      data: (0, _stringify2.default)(bodyParams),
      timeout: 25000,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(checkStatus).then(checkCode);
  },
  delete: function _delete(url, urlParams, bodyParams) {
    var token = _cookie2.default.get('token');
    urlParams = (0, _assign2.default)({}, urlParams, {
      'access_token': token
    });
    url += '?' + _qs2.default.stringify(urlParams);
    return (0, _axios2.default)({
      method: 'delete',
      url: url,
      data: (0, _stringify2.default)(bodyParams),
      timeout: 25000,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(checkStatus).then(checkCode);
  },
  all: function all(requestList) {
    requestList = requestList.map(function (item) {
      var queryParams = null;
      var urlParams = null;
      var token = _cookie2.default.get('token');
      // 设置get请求的token
      if (item.queryParams) {
        queryParams = (0, _assign2.default)({}, {
          'access_token': token
        }, item.queryParams);
      } else {
        queryParams = {
          'access_token': token
        };
      }

      // 设置post请求的token
      if (item.urlParams) {
        urlParams = (0, _assign2.default)({}, {
          'access_token': token
        }, item.urlParams);
      } else {
        urlParams = {
          'access_token': token
        };
      }

      // 发出请求
      if (item.type === 'get') {
        item.url += '?' + _qs2.default.stringify(queryParams);
        return _axios2.default.get(item.url);
      }
      if (item.type === 'post') {
        item.url += '?' + _qs2.default.stringify(urlParams);
        return _axios2.default.post(item.url, item.bodyParams, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      }
    });
    return _axios2.default.all(requestList).then(_axios2.default.spread(function () {
      for (var _len = arguments.length, resList = Array(_len), _key = 0; _key < _len; _key++) {
        resList[_key] = arguments[_key];
      }

      return checkAllStatus(resList);
    })).then(function (resObj) {
      return checkAllCode(resObj);
    });
  }
};

/***/ }),

/***/ "H7aD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'tab',
  mixins: [_multiItems.parentMixin],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "IGOp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'tab',
  mixins: [_multiItems.parentMixin],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _user = __webpack_require__("bREw");

var _user2 = _interopRequireDefault(_user);

var _tabStatus = __webpack_require__("o9jp");

var _tabStatus2 = _interopRequireDefault(_tabStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import selfMachineUser from './modules/selfMachineUser'
_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  modules: {
    user: _user2.default,
    tabStatus: _tabStatus2.default
    // selfMachineUser
  }
});
exports.default = store;

/***/ }),

/***/ "Kr/h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-App---container---1yQEW_1","boxb":"src-App---boxb---1LjqC_1","box":"src-App---box---28-0Y_1","header":"src-App---header---3qzuo_1","footer":"src-App---footer---31xbU_1"};

/***/ }),

/***/ "LQnx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ljbl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lq3S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _multiItems = __webpack_require__("piuB");

exports.default = {
  name: 'tab-item',
  mixins: [_multiItems.childMixin],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "M6Sr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("bwrR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xzd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d34fba04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Okv4");
function injectStyle (ssrContext) {
  __webpack_require__("EiRk")
  this["$style"] = __webpack_require__("Kr/h")
  __webpack_require__("j0+8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d34fba04_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _fastclick = __webpack_require__("v5o6");

var _fastclick2 = _interopRequireDefault(_fastclick);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _vueAwesomeSwiper = __webpack_require__("7QTg");

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

var _http = __webpack_require__("GVVA");

var _http2 = _interopRequireDefault(_http);

var _cookie = __webpack_require__("SXPf");

var _cookie2 = _interopRequireDefault(_cookie);

var _bluebird = __webpack_require__("0Qa9");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _index = __webpack_require__("IcnI");

var _index2 = _interopRequireDefault(_index);

var _vueLazyload = __webpack_require__("AXdl");

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

__webpack_require__("M6Sr");

__webpack_require__("9n10");

__webpack_require__("2Uyi");

__webpack_require__("Ljbl");

__webpack_require__("3KG0");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import axios from 'axios'
_vue2.default.prototype.$hostname = function () {
  if (false) {
    // return 'zscfx.yilvbao.cn'
    return 'fenxiao.yeahtour.cn';
  } else {
    return window.location.hostname;
  }
};
// import QS from 'qs';
// import AMap from 'vue-amap'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_vue2.default.use(_vueLazyload2.default, {
  // loading: '../webchat/static/lazy.svg'
  loading: __webpack_require__("Yyfi")
});

// Vue.use(AMap)
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueAwesomeSwiper2.default);
_vue2.default.use(_cookie2.default);
// AMap.initAMapApiLoader({
//   key: '43dc89a281dc12fcdbbe4230a54f25b9',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
// })
// axios.defaults.baseURL = __BASE__;
window.Promise = _bluebird2.default;
// import 'element-ui/lib/theme-chalk/index.css';
// import ElementUI from 'element-ui';


// Vue.prototype.$http = axios
_vue2.default.prototype.$userId = '';
// Vue.prototype.QS = QS
// Vue.prototype.$api = api
_vue2.default.prototype.$Cookie = _cookie2.default;
_fastclick2.default.attach(document.body);
// Vue.use(ElementUI);
Number.prototype.mul = function (arg) {
  return accMul(arg, this);
};
_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  router: _router2.default,
  store: _index2.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app-box');

function accMul(arg1, arg2) {
  var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();

  try {
    m += s1.split(".")[1].length;
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
  } catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}

/***/ }),

/***/ "Okv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.isShow
        ? _vm.isShowHead
          ? [_vm.$style.box, _vm.$style.container]
          : [_vm.$style.boxb, _vm.$style.container]
        : _vm.$style.container},[(_vm.isShowHead)?_c('Header',{class:_vm.$style.header,attrs:{"headerIndex":_vm.headerIndex}}):_vm._e(),_vm._v(" "),_c('keep-alive',[(_vm.$route.meta.keep)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keep)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('Footor',{class:_vm.$style.footer,attrs:{"index":_vm.index}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qe3P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-footer---container---1JtyJ_0","active":"src-components-footer---active---12j4L_0","size":"src-components-footer---size---icITR_0"};

/***/ }),

/***/ "SXPf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(name, value) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 11 * 60 * 60 * 1000);
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
  },
  get: function get(name) {
    // eslint-disable-next-line
    var arr = void 0,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    // eslint-disable-next-line
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  del: function del(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.get(name);
    if (cval != null) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
    }
  }
};

/***/ }),

/***/ "Vj9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W5j6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      activeIndex: 0,
      icons: [{
        icon: 'homeIcon',
        selectIcon: 'slectHomeIcon',
        name: '目的地',
        id: 'icon0'
      }, {
        icon: 'festivalIcon',
        selectIcon: 'selectFestivalIcon',
        name: '门票',
        id: 'icon1'
      }, {
        icon: 'foundIcon',
        selectIcon: 'selectFoundIcon',
        name: '发现',
        id: 'icon2'
      }, {
        icon: 'myIcon',
        selectIcon: 'selectMyIcon',
        name: '我的',
        id: 'icon3'
      }]
    };
  },

  watch: {
    index: {
      handler: function handler(newValue) {
        this.activeIndex = newValue;
      },

      immediate: true
    }
  },
  methods: {
    handleChangeIndexClick: function handleChangeIndexClick(index) {
      if (this.activeIndex === index) {
        return;
      }
      this.activeIndex = index;
      var path = '';
      if (index === 0) {
        path = '/home';
      } else if (index === 1) {
        path = '/travel';
      } else if (index === 2) {
        path = '/found';
      } else if (index === 3) {
        path = '/my';
      }
      this.$router.push({
        path: path
      });
    }
  }
};

/***/ }),

/***/ "YB+S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tab = __webpack_require__("odqc");

var _tab2 = _interopRequireDefault(_tab);

var _tabItem = __webpack_require__("Znkm");

var _tabItem2 = _interopRequireDefault(_tabItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    headerIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    Tab: _tab2.default,
    TabItem: _tabItem2.default
  },
  data: function data() {
    return {
      currentCity: '',
      activeIndex: 0
    };
  },
  mounted: function mounted() {
    var localStorageObj = localStorage.getItem('iregional') ? JSON.parse(localStorage.getItem('iregional')) : {};
    this.currentCity = localStorageObj.name || '全国';
  },

  watch: {
    headerIndex: {
      handler: function handler(newValue) {
        this.activeIndex = newValue;
      },

      immediate: true
    }
  },
  methods: {
    handleChangeCity: function handleChangeCity() {
      this.$router.push({
        path: '/changeCity'
      });
    },
    onItemClick: function onItemClick(index) {
      if (this.activeIndex === index) {
        return;
      }
      this.activeIndex = index;
      var path = '';
      if (this.activeIndex === 0) {
        path = '/home';
      } else if (this.activeIndex === 1) {
        path = '/cardList';
      } else if (this.activeIndex === 2) {
        path = '/infomation';
      } else if (this.activeIndex === 3) {
        path = '/plan';
      }
      this.$router.push({
        path: path
      });
    }
  }
};

/***/ }),

/***/ "YV66":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tab = __webpack_require__("odqc");

var _tab2 = _interopRequireDefault(_tab);

var _tabItem = __webpack_require__("Znkm");

var _tabItem2 = _interopRequireDefault(_tabItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    headerIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    Tab: _tab2.default,
    TabItem: _tabItem2.default
  },
  data: function data() {
    return {
      currentCity: '',
      activeIndex: 0
    };
  },
  mounted: function mounted() {
    var localStorageObj = localStorage.getItem('iregional') ? JSON.parse(localStorage.getItem('iregional')) : {};
    this.currentCity = localStorageObj.name || '全国';
  },

  watch: {
    headerIndex: {
      handler: function handler(newValue) {
        this.activeIndex = newValue;
      },

      immediate: true
    }
  },
  methods: {
    handleChangeCity: function handleChangeCity() {
      this.$router.push({
        path: '/changeCity'
      });
    },
    onItemClick: function onItemClick(index) {
      if (this.activeIndex === index) {
        return;
      }
      this.activeIndex = index;
      var path = '';
      if (this.activeIndex === 0) {
        path = '/home';
      } else if (this.activeIndex === 1) {
        path = '/cardList';
      } else if (this.activeIndex === 2) {
        path = '/infomation';
      } else if (this.activeIndex === 3) {
        path = '/plan';
      }
      this.$router.push({
        path: path
      });
    }
  }
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _cookie = __webpack_require__("SXPf");

var _cookie2 = _interopRequireDefault(_cookie);

var _config = __webpack_require__("bzuE");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { resolve } from 'bluebird'
// import { resolve } from 'dns'

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  // mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/protocol', // 用户隐私协议
    name: 'protocol',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(68)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NJzT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/intentionList', // 景区意向客户填写表
    name: 'intentionList',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0NHi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/smgIndex', // 扫码购--首页
    name: 'smgIndex',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("D7vu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/smgPayment', // 扫码购--支付页面
    name: 'smgPayment',
    meta: {
      title: '门票预订'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/JjQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
    // component: resolve => require(['@/pages/SMG/payment'], resolve)
  }, {
    path: '/',
    redirect: '/home'
  }, {
    path: '/groundScenic', // 景区介绍
    name: 'GroundScenic',
    // component: resolve => require(['@/pages/groundScenic/index'], resolve),
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jppv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      // keepAlive: true,
      title: '门票'
    }
  }, {
    path: '/opinion', // 用户评价
    name: 'opinion',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4wnm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用户评价'
    }
  }, {
    path: '/TicketReservation/', // 门票预定
    name: 'TicketReservation',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9Btl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    // component: resolve => require(['@/pages/TicketReservation/TicketReservation'], resolve),
    meta: {
      title: '门票预订'
    }
  }, {
    path: '/TicketsNotPaid/', // 订单未支付
    name: 'TicketsNotPaid',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(56)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EfDM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '门票预订'
    }
  }, {
    path: '/orderDetails', // 订单详情
    name: 'orderDetails',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oiOM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/refundDetails', // 订单详情--退订详情
    name: 'refundDetails',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(63)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L0KG")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/refundSuccess', // 订单详情--退订成功
    name: 'refundSuccess',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JaW/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '订单'
    }
  }, {
    path: '/SelfMachine', // 自助机退票--列表
    name: 'SelfMachine',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GG3o")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '自助机退票'
    }
  }, {
    path: '/signinSelfMachine', // 登录--自助机登录页面
    name: 'signinSelfMachine',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kFRK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用户登录'
    }
  }, {
    path: '/redirect', // 登录--重定向
    name: 'redirect',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(75)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TgSK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: ''
    }
  }, {
    path: '/signin', // 登录
    name: 'signin',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5zEw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用户登录'
    }
  }, {
    path: '/wxsignin', // 登录
    name: 'wxsignin',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ry4G")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用户注册'
    }
  }, {
    path: '/real-names', // 实名
    name: 'real-names',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FeWT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '领取旅游卡'
    }
  }, {
    path: '/realsuccess', // 实名成功
    name: 'realsuccess',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(51)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eAdy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '领取旅游卡'
    }
  }, {
    path: '/realfail', // 实名失败
    name: 'realfail',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AeYz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '领取旅游卡'
    }
  }, {
    path: '/RefundCard', // 退卡
    name: 'RefundCard',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2CUb")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '旅游卡申退'
    }
  }, {
    path: '/RefundCardall', // 全额退卡
    name: 'RefundCardall',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("W5is")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '旅游卡申退'
    }
  }, {
    path: '/cancellation', // 注销
    name: 'cancellation',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("k3Lc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '旅游卡申退'
    }
  }, {
    path: '/tkjd', // 退款进度
    name: 'tkjd',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+XaD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '旅游卡申退进度'
    }
  }, {
    path: '/newsignin', // 登录
    name: 'newsignin',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tVM8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '登录'
    }
  }, {
    path: '/register', // 注册
    name: 'register',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(73)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8zp9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '用户注册'
    }
  }, {
    path: '/forgetPwd', // 忘记密码
    name: 'forgetPwd',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(74)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aYeQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '忘记密码'
    }
  },
  // {
  //   path: '/resetPwd', // 重置密码
  //   name: 'resetPwd',
  //   component: resolve => require(['@/pages/login/pwdReset'], resolve),
  //   meta: {
  //     title: '重置密码'
  //   }
  // },
  {
    path: '/registerSucces', // 注册成功
    name: 'registerSucces',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4Mux")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '注册成功'
    }
  }, {
    path: '/certification', // 认证
    name: 'certification',
    meta: {
      title: '实名认证',
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("To25")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  // {
  //   path: '/persoanl', // 个人中心 (废弃)
  //   name: 'persoanl',
  //   component: resolve => require(['@/pages/personal/personal'], resolve)
  // },
  // {
  //   path: '/allorder/:type', // 个人中心--所有订单 (废弃)
  //   name: 'allorder',
  //   meta: {
  //     requiresAuth: true
  //   },
  //   component: resolve => require(['@/pages/personal/allOrder'], resolve)
  // },
  {
    path: '/addUserList', // 联系人列表
    name: 'addUserList',
    meta: {
      requiresAuth: true,
      title: '常用联系人'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("j6u/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
    // component: resolve => require(['@/pages/personal/addUserList'], resolve)
  }, {
    path: '/addUserInfo', // 添加联系人--新增信息
    name: 'addUserInfo',
    meta: {
      requiresAuth: true,
      title: '新增联系人'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7SRb")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
    // component: resolve => require(['@/pages/personal/addUserInfo'], resolve)
  }, {
    path: '/editUserInfo', // 添加联系人--编辑联系人
    name: 'editUserInfo',
    meta: {
      requiresAuth: true,
      title: '编辑联系人'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4yqn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
    // component: resolve => require(['@/pages/personal/editUserInfo'], resolve)
  }, {
    path: '/plan', // 攻略列表
    name: 'plan',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(69)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fc3l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '旅游攻略'
    }
  }, {
    path: '/infomation', // 资讯列表
    name: 'infomation',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(77)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("be0K")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '资讯'
    }
  }, {
    path: '/order', // 订单列表
    name: 'order',
    meta: {
      requiresAuth: true,
      title: '订单'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0wiy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/my', // 个人中心
    name: 'my',
    meta: {
      requiresAuth: true,
      title: '个人中心'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XJOZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/home', // 目的地首页
    meta: {
      title: '易旅通'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wDQo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/travel', // 目的地景区列表(门票)
    name: 'travel',
    meta: {
      title: '门票'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("R1v2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/tourGroup/:id', // 目的地景区列表(跟团游)
    meta: {
      title: '跟团游'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4dg8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/tourGroupDetail/:id', // 目的地景区列表(跟团游)
    meta: {
      title: '跟团游详情页'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GkIh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/travelSearch', // 目的地搜索景区列表(门票)
    meta: {
      title: '门票搜索'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/S6X")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/travelCard', // 旅游卡
    meta: {
      title: '旅游卡'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yorg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/travelCardDetail', // 旅游卡详情
    meta: {
      title: '旅游卡详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8w0c")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/travelCardUsageIntro', // 旅游卡使用说明
    name: 'travelCardUsageIntro',
    meta: {
      title: '旅游卡使用说明'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("15g5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/travelPay', // 旅游卡订单详情
    meta: {
      title: '订单详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+9yp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/renewCardPay', // 旅游卡续费
    meta: {
      title: '旅游卡续费'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("E9Q7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/historyCard', // 历史旅游卡
    meta: {
      title: '绑定历史旅游卡'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gBWp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/real-name', // 实名认证
    meta: {
      title: '实名认证',
      equiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("To25")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/bankList', // 我的银行卡列表
    meta: {
      title: '我的银行卡',
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hZHt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/myCard', // 我的银行卡
    meta: {
      title: '我的银行卡',
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mj/i")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/addCard', // 添加银行卡
    meta: {
      title: '添加银行卡',
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(61)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4w5V")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/addCards', // 添加银行卡
    meta: {
      title: '添加银行卡',
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(60)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("foi0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/addCardInfo', // 添加银行卡填写银行卡信息
    meta: {
      title: '填写银行卡信息',
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(59)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VA69")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/addCardInfos', // 添加银行卡填写银行卡信息
    meta: {
      title: '填写银行卡信息',
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(58)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sZan")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/confirmOpen', // 确认开通银行卡
    meta: {
      requiresAuth: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(57)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("17c9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/openSuccess', // 开通成功
    meta: {
      requiresAuth: true,
      title: '中国银联'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sDFM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/distributor', // 分销商首页
    meta: {},
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YLI5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/distributorBuy', // 分销商购票页面
    meta: {},
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lywq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
    // component: resolve => require(['../pages/distributor/groundScenic/groundScenic.vue'], resolve)
  }, {
    path: '/distributorPay', // 分销商付账
    meta: {
      title: '门票预订'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Slqs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/registerRule', // 注册条款
    meta: {
      title: '注册服务条款'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("g2VQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/privacyPolicy', // 个人信息授权条款
    meta: {
      title: '个人信息授权条款'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("t7Rg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/onBuild', // 经销商付账
    meta: {
      title: '导游导缆系统'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IC57")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/changeCity', // 切换城市
    meta: {
      title: '选择城市'
    },
    // component: resolve => require(['../pages/changeCity/index.vue'], resolve)
    component: function component(resolve) {
      return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VLgX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/traveTicketDetail', // 旅游卡买票详情
    meta: {
      title: '门票详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("b7/z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/traveTicketPay', // 旅游卡买票详情
    meta: {
      title: '订单填写'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uxUa")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/found', // 发现
    meta: {
      title: '发现'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8oRk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/activity', // 活动
    meta: {
      title: '活动'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5Q15")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/mine', // 新的我的页面（调试用）
    meta: {
      title: '我的'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XJOZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/trafficDetail',
    meta: {
      title: '交通详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ncFC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/foodDetail',
    meta: {
      title: '美食详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xzVA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/specialThingDetail',
    meta: {
      title: '特产详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("k+sa")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/hotelDetail',
    meta: {
      title: '住宿详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hUtp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/feedback',
    meta: {
      title: '意见反馈'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Y9yA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/set',
    meta: {
      title: '设置'
    },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8qud")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/resetPwd',
    meta: {
      title: '修改密码'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(72)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("W//h")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/cardList',
    meta: {
      title: '旅游卡列表'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(81)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jMbA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/myTravelCard',
    meta: {
      title: '我的旅游卡'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("patq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/myCollect',
    meta: {
      title: '我的收藏'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UziZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/intelGuide',
    meta: {
      title: '智能导览'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(76)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0HAw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/articleDetail',
    name: 'articleDetail',
    meta: {
      title: '文章详情'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2075")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/myData',
    meta: {
      title: '我的资料'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IUzw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/comment',
    meta: {
      title: '评论'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IqOq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/cityNews',
    meta: {
      title: '' // 城市预览,人文风情
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(79)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7oJH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/cityList',
    meta: {
      title: '' //
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(82)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("R5Yb")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/planSearch',
    meta: {
      title: '搜索攻略',
      keep: true
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cASt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/setHeadImg',
    meta: {
      title: '更换头像'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(71)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Rt/D")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/setMyData',
    meta: {
      title: '修改信息'
    },
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(70)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JV4e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth) {
    var token = _cookie2.default.get('mdd_token');
    var usid = localStorage.getItem(_config.userInfo) ? JSON.parse(localStorage.getItem(_config.userInfo)).userId : '';
    if (token && usid) {
      next();
    } else {
      router.replace({
        path: '/signin',
        query: {
          redirect: router.currentRoute.fullPath // 登录成功后跳入浏览的当前页面
        } });
      // next('/signin')
    }
  } else {
    next();
  }
});

router.afterEach(function (to, from) {
  var v = to.fullPath;
  var i = '/home?t=';
  var o = '/opinion?t=';
  var c = '易旅通';
  if (v.startsWith(i)) {
    c = v.substr(v.indexOf(i) + 8);
    c = decodeURIComponent(c);
    sessionStorage.setItem('indextitle', c);
  } else if (v.startsWith(o)) {
    c = v.substr(v.indexOf(o) + 11);
    c = decodeURIComponent(c);
    sessionStorage.setItem('indextitle', c);
  }
  // setTimeout(() => {
  if (sessionStorage.getItem('indextitle')) {
    document.title = sessionStorage.getItem('indextitle');
  }
  // document.title = localStorage.getItem('indextitle') == null ? c : localStorage.getItem('indextitle')
  // }, 0)
});

exports.default = router;

/***/ }),

/***/ "Yyfi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Znkm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue__ = __webpack_require__("2kPC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue__ = __webpack_require__("Lq3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_57c3c9c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_tab_item_vue__ = __webpack_require__("Vj9Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_57c3c9c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_tab_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aMtT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bREw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__("bzuE");

var Users = {
  state: {
    user: {}
  },
  mutations: {
    setUser: function setUser(state, user) {
      (0, _config.setSession)(_config.userInfo, user);
      state.user = user;
    },
    resetUser: function resetUser(state) {
      (0, _config.setSession)(_config.userInfo, {});
      state.user = {};
    }
  },
  getters: {
    getUser: function getUser(state) {
      if (!state.user.userId) {
        state.user = (0, _config.getSession)(_config.userInfo);
      }
      return state.user;
    }
  }
};

exports.default = Users;

/***/ }),

/***/ "bwrR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _header = __webpack_require__("Cz8s");

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__("mzkE");

var _footer2 = _interopRequireDefault(_footer);

var _config = __webpack_require__("bzuE");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "app",
  components: {
    Header: _header2.default,
    Footor: _footer2.default
  },
  data: function data() {
    return {
      index: 0,
      headerIndex: 0,
      isShow: false, // 展示footer
      isShowHead: false, // 展示header
      i: 0,
      scrollDirection: ""
    };
  },
  created: function created() {
    // this.headerIndex = this.$store.getters.gethomeTopTab
  },

  watch: {
    $route: function $route(to) {
      document.title = to.meta.title;
      if (to.fullPath === "/my") {
        this.index = 3;
        this.isShowHead = false;
        this.isShow = true;
      } else if (to.fullPath === "/found") {
        this.index = 2;
        this.isShow = true;
        this.isShowHead = false;
      } else if (to.path === "/travel") {
        this.index = 1;
        this.isShowHead = false;
        this.isShow = true;
      } else if (to.path === "/home") {
        this.index = 0;
        this.headerIndex = 0;
        this.isShow = true;
        this.isShowHead = true;
      } else if (to.fullPath === "/cardList") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 1;
        this.index = 0;
      } else if (to.fullPath === "/infomation") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 2;
        this.index = 0;
      } else if (to.fullPath === "/plan") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 3;
        this.index = 0;
      } else if (to.fullPath === "/order") {
        this.isShow = true;
        // this.isShowHead = true;
        this.headerIndex = 3;
        this.index = 4;
      } else {
        this.isShowHead = false;
        this.isShow = false;
      }
    }
  },
  computed: {},
  mounted: function mounted() {
    var weChatName = this.GetRequest("wxName");
    if (!weChatName) {
      weChatName = _config.wxName;
    }
    (0, _config.setSession)("wxName", { name: weChatName });
    // console.log("111111111111:", getSession("wxName").name);
    this.phoneType();
    this.$isWx = this.getIsWxClient();
    if (this.isAndroid() && this.$isWx) {
      this.adjustFont();
    }
  },

  methods: {
    /**
     * 判断是否是微信环境
     */
    getIsWxClient: function getIsWxClient() {
      var ua = navigator.userAgent.toLowerCase();
      if (String(ua.match(/MicroMessenger/i)) === "micromessenger") {
        return true;
      }
      return false;
    },
    phoneType: function phoneType() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 这个判断 是不是ios手机
      var flag;
      var myFunction;
      if (isiOS) {
        // 既是微信浏览器 又是ios============（因为查到只有在微信环境下，ios手机上才会出现input失去焦点的时候页面被顶起）
        document.body.addEventListener("focusin", function () {
          // 软键盘弹起事件
          flag = true;
          clearTimeout(myFunction);
        });
        document.body.addEventListener("focusout", function () {
          // 软键盘关闭事件
          flag = false;
          if (!flag) {
            myFunction = setTimeout(function () {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // 重点  =======当键盘收起的时候让页面回到原始位置
            }, 100);
          }
        });
      } else {}
    },
    scrollEvent: function scrollEvent() {
      var that = this;
      that.isShow = true;
      document.getElementById("app").onscroll = function () {
        var scrollTop = document.getElementById("app").scrollTop;
        var scroll = scrollTop - that.i;
        that.i = scrollTop;
        if (scroll < 0) {
          if (!that.isShow) {
            that.isShow = true;
          }
        } else {
          if (that.isShow) {
            that.isShow = false;
          }
        }
      };
    },
    GetRequest: function GetRequest(name) {
      var search = document.location.search;
      var pattern = new RegExp("[?&]" + name + "=([^&]+)", "g");
      var matcher = pattern.exec(search);
      var items = null;
      if (matcher != null) {
        try {
          items = decodeURIComponent(decodeURIComponent(matcher[1]));
        } catch (e) {
          try {
            items = decodeURIComponent(matcher[1]);
          } catch (e) {
            items = matcher[1];
          }
        }
      }
      return items;
    },
    isAndroid: function isAndroid() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 这个判断 是不是ios手机
      return !isiOS;
    },
    adjustFont: function adjustFont() {
      if ((typeof WeixinJSBridge === "undefined" ? "undefined" : (0, _typeof3.default)(WeixinJSBridge)) === "object" && typeof WeixinJSBridge.invoke === "function") {
        this.handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", this.handleFontSize, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
        }
      }
    },
    handleFontSize: function handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "bzuE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userAccount = exports.wxName = exports.mailReg = exports.prefixPath = exports.distributorTicketInfo = exports.ticketInfo = exports.userInfo = exports.tabStatus = undefined;

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

exports.setSession = setSession;
exports.getSession = getSession;
exports.removeSession = removeSession;
exports.getQueryString = getQueryString;
exports.isPoneAvailable = isPoneAvailable;
exports.isCardNo = isCardNo;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setSession(key, value) {
  if (value instanceof Object) {
    value = (0, _stringify2.default)(value);
  }
  localStorage.setItem(key, value);
}

function getSession(key) {
  var obj = localStorage.getItem(key);
  if (typeof obj === 'string') {
    obj = JSON.parse(obj);
  }
  return obj;
}

function removeSession(key) {
  localStorage.removeItem(key);
}
var tabStatus = exports.tabStatus = 'mdd_tabStatus';

var userInfo = exports.userInfo = 'mdd_userInfo';

var ticketInfo = exports.ticketInfo = 'mdd_ticketInfo';

var distributorTicketInfo = exports.distributorTicketInfo = 'mdd_distributorTicketInfo'; // 经销商的票的信息

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function isPoneAvailable(str) {
  var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

var prefixPath = exports.prefixPath = '/webchat';

function isCardNo(card) {
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X 
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (reg.test(card) === false) {
    return false;
  } else {
    return true;
  }
}

var mailReg = exports.mailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;

var wxName = exports.wxName = '四川瑞通智晟科技有限公司';
var userAccount = exports.userAccount = 'mdd_userAccount';

/***/ }),

/***/ "eMjD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJ82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j0+8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lm9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain"},[_c('div',{staticClass:"positionzoon"},[_c('span',{staticClass:"cityname",on:{"click":function($event){$event.stopPropagation();return _vm.handleChangeCity.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.currentCity))]),_vm._v(" "),_c('span',{staticClass:"arrow",on:{"click":function($event){$event.stopPropagation();return _vm.handleChangeCity.apply(null, arguments)}}})]),_vm._v(" "),_c('div',{staticClass:"tabzoon"},[_c('tab',{attrs:{"custom-bar-width":"30px"}},[_c('tab-item',{attrs:{"selected":_vm.activeIndex===0},on:{"on-item-click":_vm.onItemClick}},[_vm._v("首页")]),_vm._v(" "),_c('tab-item',{attrs:{"selected":_vm.activeIndex===1},on:{"on-item-click":_vm.onItemClick}},[_vm._v("旅游卡")]),_vm._v(" "),_c('tab-item',{attrs:{"selected":_vm.activeIndex===2},on:{"on-item-click":_vm.onItemClick}},[_vm._v("资讯")]),_vm._v(" "),_c('tab-item',{attrs:{"selected":_vm.activeIndex===3},on:{"on-item-click":_vm.onItemClick}},[_vm._v("攻略")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mzkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("rxhY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("W5j6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72dd5c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("B5zW");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("Qe3P")
  __webpack_require__("/A+z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72dd5c62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72dd5c62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "o9jp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__("bzuE");

var TabStatus = {
  state: {
    status: {
      homeTopTab: null
    }
  },
  mutations: {
    sethomeTopTab: function sethomeTopTab(state, status) {
      (0, _config.setSession)(_config.tabStatus, { homeTopTab: status });
      state.status = { homeTopTab: status };
    },
    resetTabStatus: function resetTabStatus(state) {
      (0, _config.setSession)(_config.tabStatus, { homeTopTab: null });
      state.status = { homeTopTab: null };
    }
  },
  getters: {
    gethomeTopTab: function gethomeTopTab(state) {
      if (!state.status.homeTopTab && state.status.homeTopTab !== 0) {
        state.status = (0, _config.getSession)(_config.tabStatus);
      }
      return state.status.homeTopTab;
    }
  }
};

exports.default = TabStatus;

/***/ }),

/***/ "odqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue__ = __webpack_require__("IGOp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue__ = __webpack_require__("H7aD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_039300f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_tab_vue__ = __webpack_require__("gJ82");
function injectStyle (ssrContext) {
  __webpack_require__("aMtT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_tab_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_039300f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "rxhY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      activeIndex: 0,
      icons: [{
        icon: 'homeIcon',
        selectIcon: 'slectHomeIcon',
        name: '目的地',
        id: 'icon0'
      }, {
        icon: 'festivalIcon',
        selectIcon: 'selectFestivalIcon',
        name: '门票',
        id: 'icon1'
      }, {
        icon: 'foundIcon',
        selectIcon: 'selectFoundIcon',
        name: '发现',
        id: 'icon2'
      }, {
        icon: 'myIcon',
        selectIcon: 'selectMyIcon',
        name: '我的',
        id: 'icon3'
      }]
    };
  },

  watch: {
    index: {
      handler: function handler(newValue) {
        this.activeIndex = newValue;
      },

      immediate: true
    }
  },
  methods: {
    handleChangeIndexClick: function handleChangeIndexClick(index) {
      if (this.activeIndex === index) {
        return;
      }
      this.activeIndex = index;
      var path = '';
      if (index === 0) {
        path = '/home';
      } else if (index === 1) {
        path = '/travel';
      } else if (index === 2) {
        path = '/found';
      } else if (index === 3) {
        path = '/my';
      }
      this.$router.push({
        path: path
      });
    }
  }
};

/***/ }),

/***/ "xzd6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _header = __webpack_require__("Cz8s");

var _header2 = _interopRequireDefault(_header);

var _footer = __webpack_require__("mzkE");

var _footer2 = _interopRequireDefault(_footer);

var _config = __webpack_require__("bzuE");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "app",
  components: {
    Header: _header2.default,
    Footor: _footer2.default
  },
  data: function data() {
    return {
      index: 0,
      headerIndex: 0,
      isShow: false, // 展示footer
      isShowHead: false, // 展示header
      i: 0,
      scrollDirection: ""
    };
  },
  created: function created() {
    // this.headerIndex = this.$store.getters.gethomeTopTab
  },

  watch: {
    $route: function $route(to) {
      document.title = to.meta.title;
      if (to.fullPath === "/my") {
        this.index = 3;
        this.isShowHead = false;
        this.isShow = true;
      } else if (to.fullPath === "/found") {
        this.index = 2;
        this.isShow = true;
        this.isShowHead = false;
      } else if (to.path === "/travel") {
        this.index = 1;
        this.isShowHead = false;
        this.isShow = true;
      } else if (to.path === "/home") {
        this.index = 0;
        this.headerIndex = 0;
        this.isShow = true;
        this.isShowHead = true;
      } else if (to.fullPath === "/cardList") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 1;
        this.index = 0;
      } else if (to.fullPath === "/infomation") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 2;
        this.index = 0;
      } else if (to.fullPath === "/plan") {
        this.isShow = true;
        this.isShowHead = true;
        this.headerIndex = 3;
        this.index = 0;
      } else if (to.fullPath === "/order") {
        this.isShow = true;
        // this.isShowHead = true;
        this.headerIndex = 3;
        this.index = 4;
      } else {
        this.isShowHead = false;
        this.isShow = false;
      }
    }
  },
  computed: {},
  mounted: function mounted() {
    var weChatName = this.GetRequest("wxName");
    if (!weChatName) {
      weChatName = _config.wxName;
    }
    (0, _config.setSession)("wxName", { name: weChatName });
    // console.log("111111111111:", getSession("wxName").name);
    this.phoneType();
    this.$isWx = this.getIsWxClient();
    if (this.isAndroid() && this.$isWx) {
      this.adjustFont();
    }
  },

  methods: {
    /**
     * 判断是否是微信环境
     */
    getIsWxClient: function getIsWxClient() {
      var ua = navigator.userAgent.toLowerCase();
      if (String(ua.match(/MicroMessenger/i)) === "micromessenger") {
        return true;
      }
      return false;
    },
    phoneType: function phoneType() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 这个判断 是不是ios手机
      var flag;
      var myFunction;
      if (isiOS) {
        // 既是微信浏览器 又是ios============（因为查到只有在微信环境下，ios手机上才会出现input失去焦点的时候页面被顶起）
        document.body.addEventListener("focusin", function () {
          // 软键盘弹起事件
          flag = true;
          clearTimeout(myFunction);
        });
        document.body.addEventListener("focusout", function () {
          // 软键盘关闭事件
          flag = false;
          if (!flag) {
            myFunction = setTimeout(function () {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // 重点  =======当键盘收起的时候让页面回到原始位置
            }, 100);
          }
        });
      } else {}
    },
    scrollEvent: function scrollEvent() {
      var that = this;
      that.isShow = true;
      document.getElementById("app").onscroll = function () {
        var scrollTop = document.getElementById("app").scrollTop;
        var scroll = scrollTop - that.i;
        that.i = scrollTop;
        if (scroll < 0) {
          if (!that.isShow) {
            that.isShow = true;
          }
        } else {
          if (that.isShow) {
            that.isShow = false;
          }
        }
      };
    },
    GetRequest: function GetRequest(name) {
      var search = document.location.search;
      var pattern = new RegExp("[?&]" + name + "=([^&]+)", "g");
      var matcher = pattern.exec(search);
      var items = null;
      if (matcher != null) {
        try {
          items = decodeURIComponent(decodeURIComponent(matcher[1]));
        } catch (e) {
          try {
            items = decodeURIComponent(matcher[1]);
          } catch (e) {
            items = matcher[1];
          }
        }
      }
      return items;
    },
    isAndroid: function isAndroid() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 这个判断 是不是ios手机
      return !isiOS;
    },
    adjustFont: function adjustFont() {
      if ((typeof WeixinJSBridge === "undefined" ? "undefined" : (0, _typeof3.default)(WeixinJSBridge)) === "object" && typeof WeixinJSBridge.invoke === "function") {
        this.handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", this.handleFontSize, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
        }
      }
    },
    handleFontSize: function handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.7e28602be76fa2ba2054.js